"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeIcon = void 0;
var react_1 = __importDefault(require("react"));
var NewChat_1 = require("./NewChat");
var Search_1 = require("./Search");
var DotsHoriz_1 = require("./DotsHoriz");
var DotsVertical_1 = require("./DotsVertical");
var SelectionDot_1 = require("./SelectionDot");
var Microphone_1 = require("./Microphone");
var MicrophoneOff_1 = require("./MicrophoneOff");
var SendMessage_1 = require("./SendMessage");
var GaiaTopicMeditation_1 = require("./GaiaTopicMeditation");
var GaiaTopicYoga_1 = require("./GaiaTopicYoga");
var GaiaTopicBonzai_1 = require("./GaiaTopicBonzai");
var GaiaTopicHamsa_1 = require("./GaiaTopicHamsa");
var Reroll_1 = require("./Reroll");
var Copy_1 = require("./Copy");
var ThumbsUp_1 = require("./ThumbsUp");
var ThumbsDown_1 = require("./ThumbsDown");
var ThumbsUpFilled_1 = require("./ThumbsUpFilled");
var ThumbsDownFilled_1 = require("./ThumbsDownFilled");
var Play_1 = require("./Play");
var Heart_1 = require("./Heart");
var HeartOff_1 = require("./HeartOff");
var Stones_1 = require("./Stones");
var Panel_1 = require("./Panel");
var Close_1 = require("./Close");
var NewTab_1 = require("./NewTab");
var ArrowRight_1 = require("./ArrowRight");
var ArrowDown_1 = require("./ArrowDown");
var Logo_1 = require("./Logo");
var Voice_1 = require("./Voice");
var Stop_1 = require("./Stop");
var Meditation_1 = require("./Meditation");
var Trash_1 = require("./Trash");
var Pencil_1 = require("./Pencil");
var ChevronDown_1 = require("./ChevronDown");
var ChevronUpBold_1 = require("./ChevronUpBold");
var SendChatPrompt_1 = require("./SendChatPrompt");
var makeIcon = function (name, size, customProps) {
    switch (name) {
        case 'new-chat':
            return react_1.default.createElement(NewChat_1.NewChat, { size: size });
        case 'new-tab':
            return react_1.default.createElement(NewTab_1.NewTab, __assign({ size: size }, customProps));
        case 'search':
            return react_1.default.createElement(Search_1.Search, { size: size });
        case 'dots-horiz':
            return react_1.default.createElement(DotsHoriz_1.DotsHoriz, { size: size });
        case 'dots-vertical':
            return react_1.default.createElement(DotsVertical_1.DotsVertical, { size: size });
        case 'selection-dot':
            return react_1.default.createElement(SelectionDot_1.SelectionDot, { size: size });
        case 'send-chat-prompt':
            return react_1.default.createElement(SendChatPrompt_1.SendChatPrompt, { size: size });
        case 'microphone':
            return react_1.default.createElement(Microphone_1.Microphone, { size: size });
        case 'microphone-off':
            return react_1.default.createElement(MicrophoneOff_1.MicrophoneOff, { size: size });
        case 'send-message':
            return react_1.default.createElement(SendMessage_1.SendMessage, { size: size });
        case 'gaia-topic-meditation':
            return react_1.default.createElement(GaiaTopicMeditation_1.GaiaTopicMeditation, { size: size });
        case 'gaia-topic-yoga':
            return react_1.default.createElement(GaiaTopicYoga_1.GaiaTopicYoga, { size: size });
        case 'gaia-topic-bonzai':
            return react_1.default.createElement(GaiaTopicBonzai_1.GaiaTopicBonzai, { size: size });
        case 'gaia-topic-hamsa':
            return react_1.default.createElement(GaiaTopicHamsa_1.GaiaTopicHamsa, { size: size });
        case 'reroll':
            return react_1.default.createElement(Reroll_1.Reroll, { size: size });
        case 'copy':
            return react_1.default.createElement(Copy_1.Copy, { size: size });
        case 'thumbs-up':
            return react_1.default.createElement(ThumbsUp_1.ThumbsUp, { size: size });
        case 'thumbs-down':
            return react_1.default.createElement(ThumbsDown_1.ThumbsDown, { size: size });
        case 'thumbs-up-filled':
            return react_1.default.createElement(ThumbsUpFilled_1.ThumbsUpFilled, { size: size });
        case 'thumbs-down-filled':
            return react_1.default.createElement(ThumbsDownFilled_1.ThumbsDownFilled, { size: size });
        case 'play':
            return react_1.default.createElement(Play_1.Play, { size: size });
        case 'heart':
            return react_1.default.createElement(Heart_1.Heart, { size: size });
        case 'heart-off':
            return react_1.default.createElement(HeartOff_1.HeartOff, { size: size });
        case 'stones':
            return react_1.default.createElement(Stones_1.Stones, { size: size });
        case 'panel':
            return react_1.default.createElement(Panel_1.Panel, { size: size });
        case 'pencil':
            return react_1.default.createElement(Pencil_1.Pencil, { size: size });
        case 'close':
            return react_1.default.createElement(Close_1.Close, { size: size });
        case 'arrow-down':
            return react_1.default.createElement(ArrowDown_1.ArrowDown, { size: size });
        case 'arrow-right':
            return react_1.default.createElement(ArrowRight_1.ArrowRight, { size: size });
        case 'chevron-down':
            return react_1.default.createElement(ChevronDown_1.ChevronDown, { size: size });
        case 'chevron-up-bold':
            return react_1.default.createElement(ChevronUpBold_1.ChevronUpBold, { size: size });
        case 'logo':
            return react_1.default.createElement(Logo_1.Logo, { size: size });
        case 'voice':
            return react_1.default.createElement(Voice_1.Voice, { size: size });
        case 'stop':
            return react_1.default.createElement(Stop_1.Stop, { size: size });
        case 'meditation':
            return react_1.default.createElement(Meditation_1.Meditation, { size: size });
        case 'trash':
            return react_1.default.createElement(Trash_1.Trash, { size: size });
        default: {
            // Exhaustive switch - TypeScript will error if we miss a case
            var _exhaustive = name;
            return _exhaustive;
        }
    }
};
exports.makeIcon = makeIcon;
